"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = GenerateTeamMemberLinksList;
var _react = _interopRequireDefault(require("react"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _components = require("@bluefin/components");
var _ = require("../..");
var _utils = require("../../utils");
/* eslint-disable react/prop-types */

function GenerateTeamMemberLinksList(_ref) {
  var teamMembers = _ref.teamMembers,
    allTeamMembers = _ref.allTeamMembers;
  if ((0, _isEmpty2["default"])(teamMembers)) {
    return null;
  }
  var teamMemberLinks = teamMembers.map(function (teamMember) {
    var teamMemberId = teamMember._id,
      teamMemberName = teamMember.name;
    return /*#__PURE__*/_react["default"].createElement(_components.InternalLink, {
      key: teamMemberId,
      to: (0, _.createTeamMemberSlug)(teamMember, allTeamMembers),
      event: {
        category: _components.EVENT_CATEGORIES.TEAM_EVENT_CATEGORY,
        action: _components.EVENT_ACTIONS.TEAM_VIEW_MEMBER_EVENT_ACTION,
        label: teamMemberName
      }
    }, teamMemberName);
  });
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "team-members"
  }, "Service offered by: ", (0, _utils.createCommaSeparatedList)(teamMemberLinks), ".");
}